import { ActionContext, ActionTree } from 'vuex'
import { IBusinessState, IRootState } from '@/@types'
import { fetchBusinessUser } from '@/models/business'
import { actionErrorHandling } from '@/helpers/errorHandling'

const actions: ActionTree<IBusinessState, IRootState> = {
  getBusinessUser: async (context: ActionContext<IBusinessState, IRootState>) => {
    try {
      const businessUser = await fetchBusinessUser()
      context.commit('BUSINESS_USER_UPDATED', businessUser)
    } catch (error) {
      actionErrorHandling(context, error)
      throw error
    }
  },
}

export default actions
